import React from 'react';
import { useAlbumExport } from '../../hooks/useAlbumExport';
import type { ExportSource } from '../../lib/albumExport/types';
import { AlbumExportDialog } from './AlbumExportDialog';

interface AlbumExportButtonProps {
  /** Keys the "already exported" history. */
  albumId: string;
  albumTitle: string;
  sources: ExportSource[];
  /** From canExportAlbum(). When false the button opens an explanation instead of the export. */
  canExport: boolean;
  /** Opens the access-request flow for a view-only viewer. Omit when they cannot request. */
  onRequestAccess?: () => void;
  /** Tailwind classes for the trigger, so it matches the buttons around it. */
  className: string;
  label?: string;
}

/** Export trigger plus its dialog. Use the hook and dialog directly when the trigger lives in a menu. */
export function AlbumExportButton({ albumId, albumTitle, sources, canExport, onRequestAccess, className, label = 'Export' }: AlbumExportButtonProps) {
  const exp = useAlbumExport(albumId, albumTitle, sources, canExport);
  return (
    <>
      <button type="button" onClick={exp.open} className={className}>{label}</button>
      <AlbumExportDialog exp={exp} albumTitle={albumTitle} onRequestAccess={onRequestAccess} />
    </>
  );
}
